module.exports = __webpack_public_path__ + "jira-configure-5eaffb09dc2448e52c64a0b3ef5fde14.png";